import { clsx } from "clsx";
import type { Ref, SelectHTMLAttributes } from "react";

export function Select({
  className,
  compact,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { ref?: Ref<HTMLSelectElement>; compact?: boolean }) {
  return (
    <select
      className={clsx(
        "kss-control kss-field text-neutral-900 dark:text-neutral-100",
        compact ? "h-[30px] px-2 text-[13px]" : "h-9 px-2.5 text-sm",
        className,
      )}
      {...props}
    />
  );
}
